// extracted by mini-css-extract-plugin
export default {"wrapper":"wFRX4THpPuReutuDk694","editButton":"xZjPPeEwpQAn7qwgKFVh"};